<template>
    <div class="store-card-display">
        <div class="store-contain">
          <div class="left">当前：</div>
          <div class="store-name" @click="changeStore">{{currentStore.channelName}}</div>
          <div class="right" @click="changeStore">[切换]</div>
          <div class="store-nav" @click="navToStore">
            <img class="nav-img" src="static/runtime/images/magic/nav.svg">
            门店导航
          </div>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      isShow:true
    };
  },
  props: {
    // 当前的门店
    currentStore: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed:{
    
  },
  methods: {
    // 关闭弹窗
    closeModal(){
      this.isShow = false;
    },
    changeStore(){
      this.$emit('changeStore');
    },
    // 门店导航
    navToStore(){
      this.$emit("navToStore")

    }
  },
};
</script>
<style lang="scss" scoped>
.store-card-display {
  display: flex;
  justify-content: center;
  background-color: #fff;
  height: 44px;
  width: 100%;
  .store-contain{
    display: flex;
    align-items: center;
    width: 100%;
    .left{
      width: 40px;
      margin-left: 15px;
    }
    .store-name{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: calc(100% - 160px);
    }
    .right{
      width: 45px;
    }
    .store-nav{
      width: 78px;
      height: 23px;
      line-height: 23px;
      border-radius: 23px;
      border: 1px solid #000;
      margin-right: 8px;
      display: flex;
      .nav-img{
        width: 8px;
        margin-left: 6px;
        margin-right: 2px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/components/top-store-display.vue